import { FormattedMessage } from 'react-intl';

import { RouteComponentProps } from 'react-router';

import { AppPage } from '../AppContent';
import { TabData, Tabs } from '../components/globals/Tabs';
import ServicesMenu from '../components/services/listServices/ServicesMenu';
import { useServices } from '../hooks/ServiceHooks';
import { WP_Service, WP_ServiceCategory } from '../model/models';

interface ServiceCategory {
  label: string;
  services: WP_Service[];
}

const ServicesPages: React.FC<RouteComponentProps> = (props) => {
  const { services } = useServices();

  const mapServicesByCategory = services.reduce(
    (prev: Map<string, ServiceCategory>, currentService: WP_Service) => {
      const serviceCategories = currentService.acf.service_category;
      serviceCategories?.map((cat: WP_ServiceCategory) => {
        // Creating default array for each tab of service
        if (!prev.has(cat.value)) {
          prev.set(cat.value, { label: cat.label, services: [] });
        }

        const services = prev.get(cat.value)?.services;

        // Adding the id as key in object to be able to add the service
        services?.push(currentService);

        return true;
      });

      return prev;
    },
    new Map()
  );

  // Creating Tabs
  const tabs: TabData[] = Array.from(mapServicesByCategory.entries()).map(
    ([tab, serviceCategory]) => {
      const servicesSortByCat = serviceCategory.services.sort(
        (a, b) => a.menu_order - b.menu_order
      );
      return {
        label: serviceCategory.label,
        link: '/services/tabs/' + tab,
        component: <ServicesMenu services={servicesSortByCat} />,
      };
    }
  );

  return (
    <AppPage>
      <h1 className="text-center text-2xl font-medium mb-4 mt-4">
        <FormattedMessage id="Services" />
      </h1>
      <Tabs
        id="services-tabs"
        tabs={tabs.sort((a, b) => a.label.localeCompare(b.label))}
        classT=""
        {...props}
        scrollable={false}
      />
    </AppPage>
  );
};

export default ServicesPages;
